import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import LeftSideBar from './LeftSideBar'

import hamburgerIcon from '../assets/images/craig_hamburger.png'
import setcLogo from '../assets/images/craig_setcLogo.png'
import profileIcon from '../assets/images/profileIcon.png'
import arrowIcon from '../assets/images/arrowIcon.png'

import '../css/Navbar.css'
import { affiliateData, company } from '../data/AffiliateData'
import { useTheme } from '../ThemeContext'

export default function NavBar({ activeTab, setActiveTab, impersonationMode }) {
  const navigate = useNavigate()
  const { isDarkMode, toggleDarkMode } = useTheme()

  const [isOpen, setIsOpen] = useState(false)
  const [leftSideBarOpen, setLeftSideBarOpen] = useState(false)
  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.popup-container')) {
        setShowPopup(false)
      }
    }

    if (showPopup)
      document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showPopup])

  const togglePopup = (event) => {
    event.stopPropagation()
    setShowPopup(prev => !prev)
  }

  return (
    <>
      {impersonationMode && (
        <div className='w-full flex flex-row items-center justify-center bg-yellow-300 font-mont p-4'>
          <p className='font-bold'>Impersonating {affiliateData.account.accountName}</p>
        </div>
      )}
      <nav className={`navbar max-sm:sticky max-sm:top-0 max-sm:z-30 py-4 font-mont ${isDarkMode ? 'bg-gray-800' : 'bg-nav'}`}>
        <div className='max-sm:hidden flex justify-between w-full'>
          <div onClick={() => {setActiveTab('dashboard'); navigate('/affiliate/dashboard') }} className='cursor-pointer w-40 logo ml-8'>
            <img src={company.companyLogoURL} alt='setcLogo' />
          </div>
          <div className='max-sm:hidden flex justify-end gap-10 mr-10'>
            <button
              className={`btn-underline ${activeTab === 'dashboard' ? 'active text-primaryColor' : isDarkMode && 'text-white'} hover:text-primaryColor`}
              onClick={() => { setActiveTab('dashboard'); navigate('/affiliate/dashboard') }}>
              Dashboard
            </button>
            <button
              className={`btn-underline ${activeTab === 'leads' ? 'active text-secondaryColor' : isDarkMode && 'text-white'} hover:text-secondaryColor`}
              onClick={() => { setActiveTab('leads'); navigate('/affiliate/leads?page=1&pageSize=100') }}>
              Leads
            </button>
            <button
              className={`btn-underline ${activeTab === 'subAffiliates' ? 'active text-primaryColor' : isDarkMode && 'text-white'} hover:text-primaryColor`}
              onClick={() => { setActiveTab('subAffiliates'); navigate('/affiliate/leads?page=1&pageSize=100&isSubAffiliates=1') }}>
              Sub Affiliates
            </button>
            <button
              className={`btn-underline ${activeTab === 'resources' ? 'active text-secondaryColor' : isDarkMode && 'text-white'} hover:text-secondaryColor`}
              onClick={() => { setActiveTab('resources'); navigate('/affiliate/resources') }}>
              Resources
            </button>
            <button
              className={`btn-underline ${activeTab === 'statistics' ? 'active text-primaryColor' : isDarkMode && 'text-white'} hover:text-primaryColor`}
              onClick={() => { setActiveTab('statistics'); navigate('/affiliate/statistics') }}>
              Statistics
            </button>
            {company.companyId === '6243c824-9e29-46da-94c6-96d03d8cbb84' && (
              <button
                className={`btn-underline ${activeTab === 'payments' ? 'active text-secondaryColor' : isDarkMode && 'text-white'} hover:text-secondaryColor`}
                onClick={() => { setActiveTab('payments'); navigate('/affiliate/payments') }}>
                Payments
              </button>
            )}
            <div className='flex font-mont'>
              <div className={`relative popup-container flex items-center p-2 rounded-md hover:cursor-pointer w-fit ${isDarkMode ? 'bg-gray-700' : 'bg-gray-300'}`} onClick={togglePopup}>
                <img className={`h-6 cursor-pointer ${isDarkMode && 'invert'}`} src={profileIcon} alt='profileIcon' />
                <p className={`ml-1 mr-2 ${isDarkMode && 'text-white'}`}>{affiliateData.account.accountName.split(' ')[0]}</p>
                <img className={`w-4 h-4 ${isDarkMode && 'invert'}`} style={{ transform: showPopup ? 'rotate(-90deg)' : 'rotate(90deg)'}} src={arrowIcon} alt='arrowIcon' />
                <div className={`right-5 popup-content ${showPopup ? 'visible' : ''} ${isDarkMode && 'bg-gray-700'}`}>
                  <button className={`text-left  w-full rounded-md p-1 ${isDarkMode ? 'text-white hover:bg-gray-800' : 'text-black hover:bg-gray-200'}`} onClick={() => navigate('/affiliate/account')}>My Account</button>
                  <button
                    className={`text-left w-full rounded-md p-1 mt-1 ${isDarkMode ? 'text-white hover:bg-gray-800' : 'text-black hover:bg-gray-200'}`}
                    onClick={toggleDarkMode}
                  >
                    {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:hidden'>
          <div onClick={() => setLeftSideBarOpen(true)} className='hamburger flex items-center ml-5 cursor-pointer w-full justify-between'>
            <img
              src={hamburgerIcon}
              alt='Menu'
              className='w-8 h-8 cursor-pointer'
              onClick={() => setIsOpen(!isOpen)}
            />
            <div className='flex font-mont mr-10'>
              <div className={`relative popup-container flex items-center p-2 rounded-md hover:cursor-pointer w-fit ${isDarkMode ? 'bg-gray-700' : 'bg-gray-300'}`} onClick={togglePopup}>
                <img className={`h-6 cursor-pointer ${isDarkMode && 'invert'}`} src={profileIcon} alt='profileIcon' />
                <p className={`ml-1 mr-2 ${isDarkMode && 'text-white'}`}>{affiliateData.account.accountName.split(' ')[0]}</p>
                <img className={`w-4 h-4 ${isDarkMode && 'invert'}`} style={{ transform: showPopup ? 'rotate(-90deg)' : 'rotate(90deg)'}} src={arrowIcon} alt='arrowIcon' />
                <div className={`right-5 popup-content ${showPopup ? 'visible' : ''} ${isDarkMode && 'bg-gray-700'}`}>
                  <button className={`text-left  w-full rounded-md p-1 ${isDarkMode ? 'text-white hover:bg-gray-800' : 'text-black hover:bg-gray-200'}`} onClick={() => navigate('/affiliate/account')}>My Account</button>
                  <button
                    className={`text-left w-full rounded-md p-1 mt-1 ${isDarkMode ? 'text-white hover:bg-gray-800' : 'text-black hover:bg-gray-200'}`}
                    onClick={toggleDarkMode}
                  >
                    {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <LeftSideBar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            leftSideBarOpen={leftSideBarOpen}
            setLeftSideBarOpen={setLeftSideBarOpen}
          />
        </div>
      </nav>
    </>
  )
}